export const STAGING_HOST = 'res-s-staging.cloudinary.com';
export const PROD_HOST = 'res.cloudinary.com';
